import React, {Component,} from 'react';
import {Redirect, useHistory } from 'react-router-dom';
import {Table,Card,Button,ButtonGroup,Nav,Image,Row,Col,Container,Spinner} from 'react-bootstrap';
import M from "materialize-css";
import Axios from "axios";
import Error from '../AdminPanel/Error'
import Success from '../AdminPanel/Success'
import ProductItemsList from './ProductItemListCardCont';
import OrderModal from './OrderSelectionModal';
import EditProduct from './EditProductItemCont';
import "./createorder.css";
import { base_url } from '../../globalConstants';
import { subject } from '../../service'

class CustomerDetailCard extends Component{

  constructor(props){
      super(props);
      
this.state = ({title:"***",name:"********",
            email:"**********",address:"********",phone:"********",country:"********"
            ,tinno:"**********"
            })

  }

  componentDidUpdate(prevProps) {

    // DEFAULT WORKING EZZID
    // if (this.props.info.ezz_id !== prevProps.info.ezz_id) {
      
    //    this.setState({title:this.props.info.title,name:this.props.info.name,
    //       email:this.props.info.email,address: this.props.info.address,phone:this.props.info.phone_number
      
    //   })

    // }

    if (this.props.info.ezz_id !== prevProps.info.ezz_id || this.props.info.email !== prevProps.info.email ) {
      //console.log("TINN",this.props.info.tinno)
      //console.log("Method",this.props.info.shipping_method)
       let cardType = "card";
   if ( this.props.info.payment_method == 1 )
     cardType = "card";
   else
     cardType = "cash";
       this.setState({title:this.props.info.title,name:this.props.info.name,
          email:this.props.info.email,address: this.props.info.address,phone:this.props.info.phone_number,
          country:this.props.info.country_name,tinno:this.props.info.tinno,
          shippingTypeSelected:this.props.info.shipping_method.toString(),paymentTypeSelected:cardType
      
      })

    }



  }

  render(){ 
      return(
          <Row>
          <Col>
          
          <Card className="" id="customerbasicdetailsCard">
      <Card.Body>
          <Card.Text>
              <Row>
                  <Col xs={8}>
      <h6 >Name:</h6><p className="inline">{this.state.title + " " + this.state.name}</p>
                  </Col>
                  <Col className="">
                  <Image src="assets/images/avatar-big.svg"/>
                  </Col>
              </Row>
              <Row>
                  <Col xs={8}>
                      <h6 >Address:</h6><p>{this.state.address}</p>
                  </Col>
                  <Col xs={4} className="right">
                  <h6 >Phone:</h6><p>{this.state.phone}</p>
                  </Col>
                  <Col xs = {8} className="">
                  <h6 >Email:</h6><p>{this.state.email}</p>
                  </Col>
                  <Col xs = {4} className="right">
                    <h6>Country:</h6><p>{this.state.country}</p></Col>
          {/* <Col xs = {12} className="">
                    <h6>CRIB/TIN #:</h6><p>{this.state.tinno}</p></Col> */}
              </Row>
          </Card.Text>
             </Card.Body> 
      </Card>
          </Col>
      </Row>

      )
  }
}

class CreateOrder extends Component{
    constructor(props){
        super(props);
     
        var today = new Date();
       

         
          var month = '' + (today.getMonth() + 1)
            var   day = '' + today.getDate()
           var    year = today.getFullYear()
        
           if (month.length < 2) {
             month = '0' + month;
           }
            
           if (day.length < 2) {
             day = '0' + day;
           }
           
        
           let date = [year, month, day].join('-');


        this.state = ({
          countryName: '',
            country_list: this.props.countryList,
            country_codelist: this.props.country_code_list,
            boxdata: [],
		  card_not_authorized: false,	
          current_date: date,
            productlist:new Array() ,
            productlisthtml:<div></div> ,
            product_name:"",product_price:0,product_quantity:0 ,
            product_category_options :[],
            product_edit_category :[],
            product_classification_options :[],
            product_edit_classification:[],
            product_classification:"",
            product_category:"",ordernumber:"",
         customer_id:"",order_date:date,class_id:"",
        received_date:date,tracking_number:"",shiper_order_number:"",
        weight:0,height:0,fedex_charge:0,width:0,length:0,actual_charge:0,homedelivery_charge:0,promo_type:"Not",promo_value:0,processing_fee:0,brokerage_charge:0,insurance_charge:0,remark:'',
        Weight_type:null,oldweight:0,
          //orderStatusSelected:"RTM",
          orderStatusSelected:"NEW",
          paymentTypeSelected:"cash",showSpinner:false,
          shippingTypeSelected:"0",
		  
          customer_selected_data:{},
          pendingOrders:[],ordersSelectedInModal:[],
          createNewOrder:true,holdmergedorderstatus:"RTM",
          ordernumbermerge:"",
          error:"",
          rowNumber:"",
          selectItemDetails:{},
      
          generatedOrderId: "",
		  oldgeneratedOrderId: "",
          isOrderUpdate: false,
          customer_email: "",
          serachInput: '',
          searchResult:'',
          contno:'',
          contweight:'',
          contdate:'',
          formData: {
            orderDate: '',
            containerNo: '',
            orderNo: '',
            ezzId: '',
            customerName: '',
            inboundTracking: '',
            weight: '',
            status: '',
            selectFranOptions: [],
            franchise_codelist:[],
            franchise_namelist:[],
            franchisename:'',
            franchiseid:''
            
          },
          rows: [],
          editIndex: null
          
          })

    }

    
    handleCountryChange = async (e)=>{
      let franchise_namelist = []
      let franchise_codelist = []
      console.log(e.target.value);
      this.setState({countryName: e.target.value })
      let selected_countryId = this.state.country_codelist[this.state.country_list.indexOf(e.target.value)]
      let urlfranchise = base_url+`franchisemaster/?company_country=` + selected_countryId
      const response_franchise = await Axios.get(urlfranchise)
      const selectFranOptions1 = response_franchise.data.map((fran, index) => {
        franchise_namelist.push(fran.company_name)
        franchise_codelist.push(fran.franchise_id)
        return (
          <option key={index} value={fran.franchise_id}>{fran.franchise_id}</option>
        )
      })
      this.setState({selectFranOptions:selectFranOptions1,franchise_namelist:franchise_namelist,
        franchise_codelist:franchise_codelist})
  }

    handleChange = (e) => {
      const { name, value } = e.target;
      this.setState((prevState) => ({
        formData: {
          ...prevState.formData,
          [name]: value
        }
      }));
    };
  
    handleAdd = () => {
      if (this.state.editIndex !== null) return;
      this.setState((prevState) => ({
        rows: [...prevState.rows, prevState.formData],
        formData: {
          orderDate: '',
          containerNo: '',
          orderNo: '',
          ezzId: '',
          customerName: '',
          inboundTracking: '',
          weight: '',
          status: ''
        }
      }));
    };
  
    handleEdit = (index) => {
      this.clearState();
      this.fillOrder(index.order_id)
      document.getElementById("divCreateOrder").style.display = "inline-grid"
      document.getElementById('updateOrder').style.display = "inline-grid"
      document.getElementById("saveOrderBtn").style.display = "none"
      return
      // this.setState({
      //   formData: { ...this.state.rows[index] },
      //   editIndex: index
      // });
    };
  
    handleDelete = (index) => {
      const updatedRows = [...this.state.rows];
      updatedRows.splice(index, 1);
    
      // If the deleted row was being edited, cancel editing
      const isEditingDeletedRow = this.state.editIndex === index;
    
      this.setState((prevState) => ({
        rows: updatedRows,
        editIndex: isEditingDeletedRow ? null : prevState.editIndex,
        formData: isEditingDeletedRow
          ? {
              orderDate: '',
              containerNo: '',
              orderNo: '',
              ezzId: '',
              customerName: '',
              inboundTracking: '',
              weight: '',
              status: ''
            }
          : prevState.formData
      }));
    };
    
    handleUpdate = () => {
      const updatedRows = [...this.state.rows];
      updatedRows[this.state.editIndex] = this.state.formData;
      this.setState({
        rows: updatedRows,
        formData: {
          orderDate: '',
          containerNo: '',
          orderNo: '',
          ezzId: '',
          customerName: '',
          inboundTracking: '',
          weight: '',
          status: ''
        },
        editIndex: null
      });
    };
  

    openOrderModel = ()=>{
      this.refs.ordermodel.openModal();
    }


    showSelectedModalOrders=(orderselected)=>{
      // console.log(`order selected ${orderselected}`)
      this.setState({ordersSelectedInModal:orderselected})
    }



handletableClick=(clickedrow)=>{
  //console.log(clickedrow)
 // M.toast({html: 'Clicked row '+clickedrow,classes:"white-text red rounded"});
 let productdetail = this.state.productlist[clickedrow]
 let countryoptions = this.state.product_category_options
 let classificationoptions = this.state.product_classification_options
 //console.log("handle cat",countryoptions)
 //console.log("handle cat",this.state.product_edit_category)
 this.setState({rowNumber:clickedrow})
 this.setState({selectItemDetails:productdetail})

 
   this.refs.editproduct.openModal(clickedrow,productdetail,countryoptions,classificationoptions);
}

updateProduct=(rownumber,item)=>{
  console.log("updatig list",rownumber,item)
let productlist = this.state.productlist
productlist.splice(rownumber, 1, item)
this.setState({productlist:productlist})
// this.refs.editproduct.closeModal();
// M.toast({html: 'item updated at row ' +rownumber,classes:"white-text blue rounded"});

}

deleteProduct= async (rownumber,item_id)=>{
  let tempItemId = item_id.toString()
  let updated_productlist = this.state.productlist
  console.log("DELETING ITEM HERE ",rownumber,item_id)

  if(!tempItemId.includes('item_')){
    await Axios({
      method: 'DELETE',
      url: base_url + `products/${item_id}/`
    }).then(function (response) {
      // console.log(`DELETED${tempProductId}`, response);
      M.toast({ html: `Product deleted successfully`, classes: "white-text blue rounded" })
    }).catch(function (response) {
      // console.log("NOT DELETED ERROR",response);
      M.toast({ html: `Product deletion failed`, classes: "white-text red rounded" })
    })
  }  

  updated_productlist.splice(rownumber, 1)
  await this.setState({productlist:updated_productlist})
  console.log(`ITEM ${item_id} DELETED AT ${rownumber}`)
  // this.refs.editproduct.closeModal();
  // M.toast({html: 'item deleted ' +rownumber,classes:"white-text blue rounded"});

}

handleCustomerInfo = async e => {  
  //alert(e.key)
  if(e.key == 'Enter'){
          const elems_auto_weight = document.getElementById('weight');
          elems_auto_weight.focus();
      }
}

    handleCustomerIDChange = async (ev)=>{       
      const target = ev.target;
      const name = target.name;

      let search_input = target.value
      var patt = /^EZ|ez\w{0,2}\d{0,4}/g;
      // var patt =  /^[EZez]\d{0,4}/g;
      var result = search_input.match(patt);

      this.setState({
        [name]: target.value,
        searchInput: search_input,
        searchResult: result
      })

        try{
      
        let token =localStorage.getItem("token")
        let header = {'Content-Type': 'multipart/form-data',
        'Authorization':'Token '+token,

        }

  
        var url
        var searchType

        if(this.state.searchResult){
          url= base_url+`customers/?ezz_id=&ezz_id__icontains=${this.state.searchInput}&email__icontains=&phone_number=`
          searchType = "ezzid"
        }        
        else{
          url= base_url+`customers/?ezz_id=&ezz_id__icontains=&email__icontains=${this.state.searchInput}&phone_number=`
          searchType = "email"
        }
        
        var customer_data = await Axios.get(url,header)
        // console.log(customer_data.data)
        let ezzidlist = {}
        let emaillist = {}
        let customerdataObject ={}
        
        document.getElementById("errCustomerNotAuthorized").style.display = "none"
 
        if (searchType === "ezzid") {
          for (let customer of customer_data.data.results) {
            ezzidlist[customer.ezz_id] = customer.email;
            customerdataObject[customer.ezz_id] = customer;
          }
        }
        // console.log();
        if (searchType === "email") {
          for (let customer of customer_data.data.results) {
            ezzidlist[customer.email] = customer.ezz_id;
            var tempEzId = ezzidlist[customer.email]
            customerdataObject[tempEzId] = customer;

          }
        }     

        // console.log(ezzidlist)
        // console.log(customerdataObject)
        this.setState({customer_data:customerdataObject})
        // Autoselect starts here
        var context = this;
        // /await context.setState({pendingOrders:[]})
        
        
        const elems_auto_customer = document.getElementById('customer_id');
        var options={
          data:ezzidlist,
          limit:20,
          onAutocomplete : async function(select_customer) {
            var tempEzzId ;
            if (searchType === "ezzid"){
              tempEzzId = select_customer
              context.setState({customer_id:select_customer})                
            }
            if (searchType === "email"){
              tempEzzId = ezzidlist[select_customer]
              context.setState({customer_id:tempEzzId})                
            }            
            context.setState({customer_selected_data:customerdataObject[tempEzzId]})
            const elems_auto_tracking_number = document.getElementById('tracking_number');
            elems_auto_tracking_number.focus();
          },
        
          sortFunction:  function (a, b, inputString) {
            return a.indexOf(inputString) - b.indexOf(inputString);
          },
        }
        var instance = M.Autocomplete.init(elems_auto_customer,options)
        instance.open()
      }catch(err){

        M.toast({html: 'User data cannot be fetched',classes:"white-text red rounded"});
        
        console.log(err)
        this.setState({error:<Error/>})
      }

    }
   

  

 changeTo= (e) =>{

          switch (e.target.name) {
            case "weight":
              this.setState({weight: e.target.value})
              break;
            case "height" :
              this.setState({height: e.target.value})
              break;
            case "width" :
              this.setState({width: e.target.value})
              break;
            case "length" :
              this.setState({length: e.target.value})
              break;
          }
                //this.setState({weight: e.target.value})
                 //// console.log("is change to");
                  console.log(e.target.value);
                  this.handleFormChange(e);
      }

      updateValue= (e) =>{

          switch (e.target.name) {
            case "weight":
              this.setState({weight: e.target.value})
              break;
            case "height" :
              this.setState({height: e.target.value})
              break;
            case "width" :
              this.setState({width: e.target.value})
              break;
            case "length" :
              this.setState({length: e.target.value})
              break;
          }
                   //this.setState({weight: e.target.value})
                  //console.log("is updtevalue");
                  //console.log(e.target.value);
          
      }


    handleFormChange= async (ev) =>{
     
      const target = ev.target
      const name = target.name
      //alert(target.value)
      // if(ev.key == 'Enter'){
      //     const elems_auto_weight = document.getElementById('weight');
      //     elems_auto_weight.focus();

      // }

      // const elems_auto_tracking_number = document.getElementById('tracking_number');
      // elems_auto_tracking_number.focus();

      if (name == 'franchiseid')
      {
        let selected_franchise = this.state.franchise_namelist[this.state.franchise_codelist.indexOf(ev.target.value)]
        //alert(name) //franchisename
        this.setState({
          [name]: target.value,
          franchisename: 'Franchise Selected ->  ' + selected_franchise
        });
      }
      else{
        this.setState({
          [name]: target.value
        });
      }
    }
    
    newDate=()=>{
     
      var d = new Date()
      var month = '' + (d.getMonth() + 1)
    var   day = '' + d.getDate()
   var    year = d.getFullYear()

   if (month.length < 2) {
     month = '0' + month;
   }
    
   if (day.length < 2) {
     day = '0' + day;
   }
   

   return [year, month, day].join('-');
    }

    formatDate=(date)=> {
      var d = new Date(date)
         var month = '' + (d.getMonth() + 1)
       var   day = '' + d.getDate()
      var    year = d.getFullYear()
  
      if (month.length < 2) {
        month = '0' + month;
      }
       
      if (day.length < 2) {
        day = '0' + day;
      }
      
  
      return [year, month, day].join('-');
  }
   

    componentDidMount(){
      
        M.AutoInit();





        console.log("is thissssssss working");
        

        // var elems_recieved = document.getElementById('received_date');
        var elems = document.querySelectorAll('.modal');
        let model_options = {
          dismissible:false,
        }
        var instances = M.Modal.init(elems, model_options);
        
        var elems_auto_customer = document.querySelectorAll('.autocomplete');

        var options_auto_customer={
      
          data: {}, 
          limit:20,
          onAutocomplete :function(select_customer) {
           
            // context.setState({ order_date: selecteddata});
            //  console.log("slect autocomplete",select_customer); 
          },
        
          sortFunction:  function (a, b, inputString) {
            return a.indexOf(inputString) - b.indexOf(inputString);
          },
        } 
        var instances_auto = M.Autocomplete.init(elems_auto_customer, options_auto_customer);
      

         
        var context = this;

       var newdate = this.newDate()
      //  console.log('new date',newdate)
        var elems_order = document.getElementById('order_date');
      
        var options_order={
            //selectMonths: true, // Enable Month Selection
            selectYears: 10, // Creates a dropdown of 10 years to control year
            format:'yyyy-mm-dd',
            autoClose :true,
            defaultDate:newdate,
            setDefaultDate :true,
            onSelect: function(date) {
              // console.log(context.formatDate(date))
               let selecteddata = context.formatDate(date)
              // console.log('selectedate',selecteddata)
              context.setState({ order_date: context.formatDate(selecteddata)})
              // console.log("order_date",selecteddata); // Selected date is logged
            },
          }
        var instances = M.Datepicker.init(elems_order, options_order);
        var elems_recieved = document.getElementById('received_date');
		elems_recieved.disabled = true;  //220223
		
        var options_recieved={
            //selectMonths: true, // Enable Month Selection
            selectYears: 1, // Creates a dropdown of 10 years to control year
            format:'yyyy-mm-dd',
            autoClose :true,
            defaultDate:newdate,
            setDefaultDate :true,
            onSelect: function(date) {
              let selecteddata = context.formatDate(date)
              context.setState({ received_date: selecteddata.toString()});
              //  console.log("recived_datae"+ selecteddata); // Selected date is logged
            },
          }
        var instances = M.Datepicker.init(elems_recieved, options_recieved);
          instances.toString()
    
    
    }


// @TODO: handlechange for create order is pending Please implement it


     addProductTolist = ()=>{
      // console.log(this.state.productname + this.state.productprice +this.state.productquantity)
       var prodname =this.state.product_name
       var prodquant =this.state.product_quantity
       var prodcat =this.state.product_category
       var prodclass = this.state.product_classification
      //  console.log("prody")
      //  console.log(prodname + prodquant+prodcat )

       //if(prodname === "" || prodquant === 0 || prodcat ==="" || prodclass === ""){
        if(prodname === "" || prodquant === 0 ){
        M.toast({html: 'Incorrect or Empty details',classes:"white-text red rounded"});
       }else{
        var elem = document.getElementById('addProductModal')
        var instance = M.Modal.getInstance(elem);
        instance.close();
        let totalproducts = this.state.productlist.length + 1
        
        let newitem = {id:'item_'+totalproducts,productName:this.state.product_name,
        productPrice:this.state.product_price ,
        productQuantity:this.state.product_quantity,
      productCategory:this.state.product_category,
      productClassification:this.state.product_classification
      }

        // console.log("Product List",this.state.productlist)
       this.state.productlist.push(newitem)
        this.setState({productlist: this.state.productlist})
        
      try {
        // this.setState({productlisthtml:<ProductItemsList products={this.state.productlist}/>})
        this.setState({product_name:"",product_price:0,product_quantity:0 })
       M.toast({html: 'Added in list successfully',classes:"white-text orange rounded"})
      } catch (error) {
        M.toast({html: 'Couldnt be added',classes:"white-text orange rounded"})
      }
       
    
       }

    }

  
    cancelOrder = ()=>{
        //window.location.reload();
        this.hideContainer()
   }

   closeContainer = async () => {
    var result = window.confirm("Are you sure, close container?");
    if (result == true) {
      var totalWgt = 0;
      this.state.boxdata.map((row, index) => (
        totalWgt = totalWgt + row.weight 
        ))
        //alert(totalWgt)
        try {
          let token = localStorage.getItem("token")
          const header = {
            'Content-Type': 'application/json',
            'Authorization': 'Token ' + token,
  
          }
          var orderupdateForm = new FormData()
          orderupdateForm.append("box_weight", totalWgt)
        
          let urlforOrderStatusUpdate = base_url+`boxes_out/${this.state.contno}/`
          const response = await Axios.patch(urlforOrderStatusUpdate, orderupdateForm, header)
  
          console.log(`box weight update succesfully ${response.data}`)
          //this.setState({ error: <Success message=" Order Status Updated" /> })
          M.toast({ html: 'Container Closed Successfull', classes: "white-text orange rounded" });
        } catch (error) {
          M.toast({ html: 'Updation Failed', classes: "white-text red rounded" });
          console.log(error)
          this.setState({ error: <Error /> })
        }
      window.location.reload();
    }
   }

   updateContainerWeight = async (totalWgt) => {
    try {
      let token = localStorage.getItem("token")
      const header = {
        'Content-Type': 'application/json',
        'Authorization': 'Token ' + token,

      }
      var orderupdateForm = new FormData()
      orderupdateForm.append("box_weight", totalWgt)
    
      let urlforOrderStatusUpdate = base_url+`boxes_out/${this.state.contno}/`
      const response = await Axios.patch(urlforOrderStatusUpdate, orderupdateForm, header)

      console.log(`box weight update succesfully ${response.data}`)
      this.setState({ contweight: totalWgt })
      //this.setState({ error: <Success message=" Order Status Updated" /> })
      M.toast({ html: 'Container weight refreshed!', classes: "white-text orange rounded" });
    } catch (error) {
      M.toast({ html: 'Updation Failed', classes: "white-text red rounded" });
      console.log(error)
      this.setState({ error: <Error /> })
    }
}

fillOrder = async (orderid) => {
  const response = await Axios.get(base_url+"boxes_received/?search=" + orderid)
  this.setState({customer_id:response.data.results[0].ezz_id,tracking_number: response.data.results[0].inbound_tracking_number,
    shiper_order_number: response.data.results[0].shipper_number,
    weight:response.data.results[0].weight,
    oldweight:response.data.results[0].weight,
    width:response.data.results[0].breadth,
    length:response.data.results[0].length,
    height:response.data.results[0].height,
    generatedOrderId:response.data.results[0].order_id,
    order_date:response.data.results[0].order_date,
    received_date:response.data.results[0].received_date,
    isOrderUpdate: true
  })
  await this.getproducts(this.state.generatedOrderId)
}

loadOrderList = async (boxid) => {
  const response = await Axios.get(base_url+"boxes_received/?box_id="  + boxid)
  //const response = await Axios.get(base_url+"boxes_received/?search="  + boxid)
  //boxdata = {response.data.results}
  this.setState({boxdata: response.data.results})
}

  createOrderNormal = async () => {
   
    const found = this.state.productlist.find(element => element["productPrice"]==0);

    console.log('found', found)

    if((this.state.width < 0 || this.state.height <0 || this.state.weight <= 0 || this.state.length <0 || this.state.actual_charge <0)
      && this.state.orderStatusSelected !== 'YTA' ){
      //M.toast({html: "Dimension values can not be 0/negative.",classes:"white-text red rounded"});
      M.toast({html: "Weight value can not be 0/negative.",classes:"white-text red rounded"});
      return;
    }

    if(found && this.state.orderStatusSelected === 'RTM' ){
      M.toast({ html: 'Ready to Manifest not allowed for product price $0', classes: "white-text red rounded" });
      return
    }
    
    //this.setState({isOrderUpdate: true})
    let token = localStorage.getItem("token")
    const header = {
      'Content-Type': 'application/json',
      'Authorization': 'Token ' + token,

    }

    console.log("create new order" + this.state.createNewOrder)

    if (this.state.createNewOrder) {

      // new order creation
      console.log("Deleting previous orders if any")
      this.state.productlist.forEach(async (item) => {
        console.log("productlist -----", item.id)
        console.log(item)
        try {

          let urlfordeletion = base_url+`products/${item.id}/`
          const response = await Axios.delete(urlfordeletion,
            header)
          console.log(`deletion response ${response.data}`)
          console.log("Product delete success")
          M.toast({ html: 'Product deletion Successful', classes: "white-text red rounded" });
        } catch (error) {
          M.toast({ html: 'No old products found', classes: "white-text green rounded" });
          console.log(error)
        }

      });


      var Orderformdata = new FormData()
      // console.log("orderid"+orderid)
      console.log(this.state.fedex_charge)
      console.log(this.state.actual_charge)
      // Orderformdata.append("order_id",orderid.toString())
      Orderformdata.append("ezz_id", this.state.customer_id)
      Orderformdata.append("box_id", this.state.contno)
      Orderformdata.append("shipper_number", this.state.shiper_order_number)
      Orderformdata.append("billing_id", "2121")
      Orderformdata.append("billing_type", this.state.paymentTypeSelected)
      Orderformdata.append("shipping_method", this.state.shippingTypeSelected)

      Orderformdata.append("order_date", this.state.order_date)
      Orderformdata.append("received_date", this.state.received_date)
      Orderformdata.append("inbound_tracking_number", this.state.tracking_number)
      Orderformdata.append("weight", this.state.weight)
      Orderformdata.append("length", this.state.length)
      Orderformdata.append("breadth", this.state.width)
      Orderformdata.append("height", this.state.height)
      Orderformdata.append("charge_type", "VAT")
      Orderformdata.append("freight_charge", this.state.fedex_charge)
      Orderformdata.append("actual_charge", this.state.actual_charge)
      Orderformdata.append("current_status", this.state.orderStatusSelected)
      Orderformdata.append("previous_status", this.state.orderStatusSelected)
      Orderformdata.append("status", "Active")
      Orderformdata.append("flag", "1")
      Orderformdata.append("homedelivery_charge", this.state.homedelivery_charge)
	  Orderformdata.append("insurance", this.state.insurance_charge)
	  Orderformdata.append("brokerage", this.state.brokerage_charge)
	  Orderformdata.append("processing", this.state.processing_fee)
	  Orderformdata.append("promo_type", this.state.promo_type)
      Orderformdata.append("promo_value", this.state.promo_value)
      Orderformdata.append("remark", this.state.remark)    

      // console.log(JSON.stringify(Orderformdata))
      // console.log("-------------------")
      // console.log(JSON.stringify(this.state))
      // console.log("-------------------")


      // @Todo: APi to be called to save data for state

      try {

        const response = await Axios.post(base_url+"boxes_received/", Orderformdata,
          header)

        const orderid = response.data.order_id
        console.log("orderid" + orderid)
        this.state.productlist.forEach(async (item) => {
          console.log("productitem")
          console.log(item)
          try {
            var productformdata = new FormData()
            productformdata.append("order_id", orderid.toString())
            productformdata.append("description", item.productName)
            productformdata.append("quantity", item.productQuantity)
            productformdata.append("unit_price", item.productPrice)
            productformdata.append("inspection_status", "okay")
            productformdata.append("status", "Active")
            // productformdata.append("category", item.productCategory)
            // productformdata.append("classification",item.productClassification)
            productformdata.append("category", "555")
            productformdata.append("classification","PAINT")

			      productformdata.append("in_tracking_no", this.state.tracking_number)

            const response_products = await Axios.post(base_url+"products/", productformdata,
              header)
            // alert(response.data)
            console.log("Product added Successfully")
            this.setState({ error: <Success message=" Order Status Updated" /> })
            M.toast({ html: 'Product Addition Successfull', classes: "white-text blue rounded" });
          } catch (error) {
            M.toast({ html: 'Product Addition Failed', classes: "white-text red rounded" });
            console.log(error)
          }

        });

		const checkCustomerAuth = this.state.customer_selected_data.card_authorize
		//M.toast({ html: checkCustomerAuth, classes: "white-text red rounded" });
		
			
        this.setState({ error: <Success message=" New order foproduct items created" /> })
        M.toast({ html: 'Order created successfully', classes: "white-text orange rounded" })
        this.setState({ error: "" })
        this.setState({ generatedOrderId: orderid })
        console.log('generatedOrderId',this.state.generatedOrderId);
        var combweight = parseInt(this.state.contweight) + parseInt(this.state.weight)
        this.updateContainerWeight(combweight)

        //document.getElementById("printLabel").disabled = false
		
        await this.loadOrderList(this.state.contno)
        document.getElementById("divCreateOrder").style.display = "none"
        //await this.getproducts(orderid)

      } catch (err) {

        M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });

        console.log(err)
        this.setState({ error: <Error /> })
      }




    } else {


      try {
        let token = localStorage.getItem("token")
        const header = {
          'Content-Type': 'application/json',
          'Authorization': 'Token ' + token,

        }
        var orderupdateForm = new FormData()
        orderupdateForm.append("shipper_number", this.state.shiper_order_number)
        // orderupdateForm.append("billing_id","2121")
        orderupdateForm.append("billing_type", this.state.paymentTypeSelected)
        orderupdateForm.append("shipping_method", this.state.shippingTypeSelected)

        orderupdateForm.append("order_date", this.state.order_date)
        orderupdateForm.append("received_date", this.state.received_date)
        orderupdateForm.append("inbound_tracking_number", this.state.tracking_number)
        orderupdateForm.append("weight", this.state.weight)
        orderupdateForm.append("length", this.state.length)
        orderupdateForm.append("breadth", this.state.width)
        orderupdateForm.append("height", this.state.height)
        // orderupdateForm.append("charge_type","VAT")
        orderupdateForm.append("freight_charge", this.state.fedex_charge)
        orderupdateForm.append("actual_charge", this.state.actual_charge)
        orderupdateForm.append("current_status", this.state.orderStatusSelected)
		orderupdateForm.append("remark", this.state.remark)
        let urlforOrderStatusUpdate = base_url+`boxes_received/${this.state.ordernumber}/`
        const response = await Axios.patch(urlforOrderStatusUpdate, orderupdateForm, header)

        console.log(`order status update succesfully ${response.data}`)
        this.setState({ error: <Success message=" Order Status Updated" /> })
        M.toast({ html: 'Updated Successfull', classes: "white-text orange rounded" });
      } catch (error) {
        M.toast({ html: 'Updation Failed', classes: "white-text red rounded" });
        console.log(error)
        this.setState({ error: <Error /> })
      }

    }
    
    document.getElementById('saveOrderBtn').disabled = true

  }
   addOrderToDB = async ()=>{
    //this.clearState();
    //return
              let token =localStorage.getItem("token")
              const  header = {'Content-Type': 'application/json',
              'Authorization':'Token '+token,
            
              }
            
                  
                  this.createOrderNormal()
                  //this.loadOrderList(this.state.contno);
                  //this.clearState();
                  //var btn = document.getElementById('createorder')
                  //btn.click()
                 // window.location.reload(false);

  }

  printLabelManually = () => {
    document.getElementById("divCreateOrder").style.display = "none"
    return

    var order_id = this.state.generatedOrderId
	if (order_id.length == 0 )
		order_id = this.state.oldgeneratedOrderId
    console.log("generatedOrderId:", order_id)

      Axios({
        method: 'post',
        url: base_url+'status_printer',
        data: {
          "order_id": order_id
        }
      }).then(function (response) {
        console.log(response)
        console.log("printer APi success");
        M.toast({
          html: `Print Label successful for orderId: ${order_id} `,
          classes: "center white-text green rounded"
        })
      }).catch(function (response) {
        console.log(response)
        console.log('printer API failed');
        M.toast({
          html: `Print Label unsuccessful`,
          classes: "white-text orange rounded"
        })
      })
      
  }

  //UPDATE ORDER START

  getproducts = async (orderid) => {
    // http://localhost:8000/api/v1/ezzytrace/products/?order_id=
    try {
      let token = localStorage.getItem("token")
      // let header = {'Content-Type': 'multipart/form-data',
      // 'Authorization':'Token '+token,

      // }

      var config = {
        headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Token ' + token },

      };

      var url = base_url+`products/?order_id=${orderid}`
      let products = await Axios.get(url, config)
      // console.log("***orderlist-openmodel")
      // console.log(products.data)
      // await this.setState({productlisthtml:<ProductItemsList products={new Array()}/>})
      var items = new Array()
      products.data.forEach((product) => {
        let newitem = {
          id: product.id, productName: product.description,
          productPrice: product.unit_price, productQuantity: product.quantity,
          productCategory: product.category,productClassification:product.classification
        }
        items.push(newitem)
        // this.state.productlist.push(newitem)
      })

      M.toast({ html: 'Fetched products for selected order', classes: "white-text orange rounded" });
      // this.setState({error:<Success/>})


      await this.setState({ productlist: items })


      // await this.setState({ productlisthtml: <ProductItemsList orderid={orderid} products={items} rowclick={this.handletableClick} /> })


    } catch (error) {
      console.log(error)
      M.toast({ html: 'Failed to fetch products', classes: "white-text red rounded" });
      // this.setState({error:<Error/>})
    }
  }

  updateOrderDB= async(header)=>{
    const  orderid= this.state.generated_orderId

    const found = this.state.productlist.find(element => element["productPrice"]==0);

    console.log('found', found)
    // console.log('this.state.generated_orderId', this.state.generated_orderId)
    // console.log('orderid', orderid)

    if(found && this.state.orderStatusSelected === 'RTM' ){
      M.toast({ html: 'Ready to Manifest not allowed for product price $0', classes: "white-text red rounded" });
      return
    }

      try{
          
          var orderupdateForm = new FormData()
          // orderupdateForm.append("order_id",this.state.generated_orderId)
          orderupdateForm.append("ezz_id",this.state.customer_id)
          orderupdateForm.append("shipper_number",this.state.shiper_order_number)
          orderupdateForm.append("billing_id","2121")
          orderupdateForm.append("billing_type",this.state.paymentTypeSelected)
          orderupdateForm.append("shipping_method", this.state.shippingTypeSelected)

          orderupdateForm.append("order_date",this.state.order_date)
          orderupdateForm.append("received_date",this.state.received_date)
          orderupdateForm.append("inbound_tracking_number",this.state.tracking_number)
          orderupdateForm.append("weight",this.state.weight)
          orderupdateForm.append("length",this.state.length)
          orderupdateForm.append("breadth",this.state.width)
          orderupdateForm.append("height",this.state.height)
          orderupdateForm.append("charge_type","VAT")
          orderupdateForm.append("freight_charge",this.state.fedex_charge)
          orderupdateForm.append("actual_charge",this.state.actual_charge)
          orderupdateForm.append("current_status",this.state.orderStatusSelected)
          // orderupdateForm.append("previous_status",this.props.orderdata.current_status)
          orderupdateForm.append("status","Deactive")
          orderupdateForm.append("flag","1")
          orderupdateForm.append("homedelivery_charge", this.state.homedelivery_charge)
		  orderupdateForm.append("insurance", this.state.insurance_charge)
		  orderupdateForm.append("brokerage", this.state.brokerage_charge)
		  orderupdateForm.append("processing", this.state.processing_fee)
		  orderupdateForm.append("promo_type", this.state.promo_type)
          orderupdateForm.append("promo_value", this.state.promo_value)
		orderupdateForm.append("remark", this.state.remark)
          let urlforOrderStatusUpdate = base_url+`boxes_received/${this.state.generatedOrderId}/`
          const response = await Axios.patch(urlforOrderStatusUpdate,orderupdateForm, header)
    
          // console.log(`order status update succesfully ${response.data}`)
          this.setState({error:<Success message=" Order Updated"/>})
        
          M.toast({html: 'Order Updated Successfull',classes:"white-text orange rounded"});
          var combweight = parseInt(this.state.contweight) + parseInt(this.state.weight) - parseInt(this.state.oldweight)
          this.updateContainerWeight(combweight)
  
  
          //Updating The Product 
  
          this.state.productlist.forEach(async(item)=>{
            try{
              var productformdata = new FormData()
              productformdata.append("order_id",this.state.generatedOrderId)
              productformdata.append("description",item.productName)
              productformdata.append("quantity",item.productQuantity)
              productformdata.append("unit_price",item.productPrice)
              productformdata.append("inspection_status","okay")
              productformdata.append("status","Active")
              productformdata.append("category","555")
              productformdata.append("classification","PAINT")

			  productformdata.append("in_tracking_no", this.state.tracking_number)
  
              console.log('ITEM-ID',item.id);

              if( typeof(item.id) === "number" && this.state.isOrderUpdate ){
                const response_products = await Axios.patch(base_url+`products/${item.id}/`, productformdata,
                  header)
                // alert(response.data)
                console.log("Product added Successfully")
                this.setState({ error: <Success message=" Order Status Updated" /> })
                M.toast({ html: 'Product Updation Successfull', classes: "white-text blue rounded" });
                
              }else{
                
                const response_addProduct = await Axios.post(base_url+`products/`, productformdata,
                header )
  
                M.toast({ html: 'Product Addition Successfull', classes: "white-text blue rounded" });
                
              }
  
              
              
            }catch(error){
              M.toast({html: 'Product Updation Failed',classes:"white-text red rounded"});
                console.log(error)
            }
           
          });
          
  
         //await this.getproducts(this.state.generatedOrderId)
         await this.loadOrderList(this.state.contno)
  
          // window.location.reload(false);
        }catch(error){
          M.toast({html: 'Order Updation Failed',classes:"white-text red rounded"});
            console.log(error)
            this.setState({error:<Error/>})
        }
  
  }
  
  //updateOrderDB= async(header)=>{
  clearState= () =>{
    var today = new Date();
          var month = '' + (today.getMonth() + 1)
            var   day = '' + today.getDate()
           var    year = today.getFullYear()
        
           if (month.length < 2) {
             month = '0' + month;
           }
            
           if (day.length < 2) {
             day = '0' + day;
           }
           
        
           let date = [year, month, day].join('-');
    this.setState({ordernumber:"",
    customer_id:"",order_date:date,
   received_date:date,tracking_number:"",shiper_order_number:"",generatedOrderId:"",
   weight:0,height:0,width:0,length:0,productlist:new Array() ,
   productlisthtml:<div></div> })
  }
  createContainer=async()=>{
    // this.setState({contno:"250" , contweight:"550", contdate:"2025-2525"})
    // this.showContInfo()
    // this.loadOrderList(250)
    // return
    let token = localStorage.getItem("token")
    let operator_id = sessionStorage.getItem("user_id")   
    console.log('USER OPERATOR ID', operator_id );            
    let header = {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Token ' + token,

    }
    var config = {
      headers: { 'Content-Type': 'multipart/form-data', 'Authorization': 'Token ' + token },

    };
    if (this.state.franchiseid == null){
      M.toast({html: 'Please fill the details.',classes:"white-text red rounded"});
      return
    }
    if (this.state.franchiseid.length <= 3)
    {
      M.toast({html: 'Please fill the details.',classes:"white-text red rounded"});
      return
    }

    try {
      var createboxform = new FormData()
      createboxform.append("box_weight", "0")
      createboxform.append("box_status", "NEW")
      createboxform.append("shipped_by", operator_id)
      createboxform.append("franchise_id", this.state.franchiseid)
      let urlboxoutbound = base_url+`boxes_out/`
      const boxout_response = await Axios.post(urlboxoutbound, createboxform, config)
      var box_id = boxout_response.data.box_id
      var boxdate = boxout_response.data.created_at
      this.setState({contno:box_id , contweight:"0", contdate:boxdate})
      this.showContInfo()
    }catch(err){
      M.toast({html: 'Container cannot be created.',classes:"white-text red rounded"});
      console.log(err)
      this.setState({error:<Error/>})
    }
  }
  
  showContInfo=()=>{
    document.getElementById("divContainerInfo").style.display = "inline-grid"
    document.getElementById("divOrderList").style.display = "inline-grid"
    document.getElementById('saveOrderBtn').disabled = false
    document.getElementById("btnCreateContainer").style.display = "none"
    //alert(this.state.contno)
    //this.loadOrderList(this.state.contno);
  }

  showContainer=()=>{
    this.clearState();
    document.getElementById("divCreateOrder").style.display = "inline-grid"
    document.getElementById("saveOrderBtn").style.display = "inline-grid"
    document.getElementById('saveOrderBtn').disabled = false
    document.getElementById("updateOrder").style.display = "none"
  }

  showContainerEdit=()=>{
    document.getElementById("divCreateOrder").style.display = "inline-grid"
    document.getElementById("updateOrder").style.display = "inline-grid"
    document.getElementById('updateOrder').disabled = false
    document.getElementById("saveOrderBtn").style.display = "none"
  }

  hideContainer=()=>{
    document.getElementById("divCreateOrder").style.display = "none"
    document.getElementById('saveOrderBtn').disabled = false
    document.getElementById("updateOrder").style.display = "none"
    this.loadOrderList(this.state.contno);
  }

  updateOrder=()=>{
      let token =localStorage.getItem("token")
      const  header = {'Content-Type': 'application/json',
      'Authorization':'Token '+token,
      }
      this.updateOrderDB(header)
      this.hideContainer()
      //this.clearState();
  }

  

render(){
  const selectCounrtyOptions = this.state.country_list.map((country, index) => {

    return (
      <option key={index} value={country}>{country}</option>
    )
  })

  const { formData, rows, editIndex } = this.state;
  const opts={};
   opts['readOnly'] = 'readOnly';
  const catlist = this.state.product_category_options;
  if (catlist.length >0){
    var categoryList = catlist.map((item, i) => {
      return (
        <option className="black-text" key={i} value={item.category_id}>{item.category_name}</option>
      )
    }, this);
  }
  const classlist = this.state.product_classification_options;
  if (classlist.length >0){
    var classificationList = classlist.map((item, i) => {
      return (
        <option className="black-text" key={i} value={item.name}>{item.description}</option>
      )
    }, this);
  }
  

    return(
        <Container>
{/* Edit product Table items */}
<EditProduct ref="editproduct" rowNumber={this.state.rowNumber}
productDetails={this.state.selectItemDetails}
 productcategory={this.state.product_edit_category}
 productclassification={this.state.product_edit_classification}
 updateBtnClick={this.updateProduct} deleteBtnClick={this.deleteProduct}

 disablePrice= {this.state.orderStatusSelected ==="IM"} 
 />




        {/* Model for adding products STARTS here */}
        {/* <!-- Modal Trigger --> */}
        <div id="addProductModal" className="modal modal-fixed-footer">
          <div className="modal-content">
            <h4 className="center orange-text"> Add Product </h4>
            <Row>
              <Col xs={12} >
                <form>
                  <Row>
                    <Col className=" rowdivPading " xs={12}>
                      <div className="input-field col s6 offset-s3 center">
                        <input name="product_name" id="product_name" type="text" value={this.state.product_name} onChange={this.handleFormChange} className="" />
                        <label htmlFor="product_name" className="black-text" >Product Name</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Enter a valid Product Name</span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="product_quantity" id="product_quantity" min="0" type="number" value={this.state.product_quantity} onChange={this.handleFormChange} className="" />
                        <label htmlFor="product_quantity" className="black-text active">Quantity</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Enter number of products items</span>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="product_price" disabled={this.state.orderStatusSelected === "IM"} id="product_price" min="0" type="number" value={this.state.product_price} onChange={this.handleFormChange} className="" />
                        <label htmlFor="product_price" className="black-text active">Product Price</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Enter numbers</span>
                      </div>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </div>
          <div className="modal-footer" >
            {/* <a href="#!" className="modal-close waves-effect waves-green btn-flat">Agree</a> */}



            <ButtonGroup className="mr-2" aria-label="First group">
              <Button id="cancelItemAddBtn" variant="outline-secondary" className="mr-4 btn modal-close "  >Cancel</Button>
              <Button id="addItemBtn" variant="outline-primary" className="mr-2 btn" onClick={this.addProductTolist}> Add</Button>

            </ButtonGroup>

          </div>
        </div>

        {/* Model for adding produts ENDS here */}

   
           

            <Row>
            <Col xs={6} md={2} lg={2}>
                    Select Country<br/>
                </Col>
<Col xs={6} md={2} lg={2}>
<div>
                    <select id="country_name_select" name="country_name" className="browser-default country_name_select" value={this.state.countryName} onChange={this.handleCountryChange}>
                        <option value=""  >Choose Country</option>
						{/* <option value="ALL"  >ALL</option> */}
            {selectCounrtyOptions}
                    </select>
                </div>
</Col>
<Col xs={6} md={2} lg={2}>
                    Select Franchise <br/>
                </Col>
<Col xs={6} md={2} lg={2}>
<div>
                    <select id="francise_name_select" name="franchiseid" className="browser-default country_name_select" value={this.state.franchiseid} onChange={this.handleFormChange}>
                        <option value=""  >Choose Franchise</option>
						{/* <option value="ALL"  >ALL</option> */}
                       {this.state.selectFranOptions}
                    </select>
                </div>
</Col>
<Col>
<Button className="ml-5 white-text" id="btnCreateContainer" variant="success" onClick={this.createContainer} >Create Container</Button>                        
</Col>
</Row >
<Row>
  <Col><span style= {{ fontSize: "large", fontWeight: "500", color: "orange" }} >{this.state.franchisename}</span></Col>
  <Col>
      </Col>
 </Row> 
<div id="divContainerInfo" style= {{ width:"100%" , display: "none"  }}>
<Row>
  <Col><b>Container No</b></Col>
  <Col>
    <span style= {{ fontSize: "large", fontWeight: "500", color: "blue" }} >{this.state.contno}</span>
  </Col>
  <Col><b>Container Weight</b></Col>
  <Col>
      <span style= {{ fontSize: "large", fontWeight: "500", color: "blue" }} >{this.state.contweight}</span>
      {/* <label htmlFor="tracking_number">{this.state.contweight}</label> */}
  </Col>
  <Col><b>Container Date</b></Col>
  <Col>
    <span style= {{ fontSize: "large", fontWeight: "500", color: "blue" }} >{this.state.contdate}</span>
  </Col>
</Row>
<Row>
<Col><Button className="ml-5 white-text" id="btnPrintContLabel" variant="info" onClick={this.printLabelManually} >Print Container Label</Button> 
  </Col>
  <Col></Col>
    
  <Col><Button className="ml-5 white-text" id="btnAddContainer" variant="info" onClick={this.showContainer} >Add to Container</Button>                        
  </Col>
  
</Row>
</div>
<div id="divCreateOrder" style= {{ display: "none"  }}>
<div className="row">
          <div className="col s3">
          <h4 className=" orange-text">Create Order</h4>
          </div>
       
</div>
                <Row>

                       <Col xs={12}md={7} lg={7}>
                    <div className="row">
    <form className="col s12" autocomplete="off">
      {this.state.error}
      <div className="row inputbox-height">
        <div className="input-field col s6">
          <input name="customer_id" id="customer_id" type="text" className="autocomplete"
            value={this.state.customer_id} 
            onChange={this.handleCustomerIDChange}
            //onKeyDown={this.handleCustomerInfo}

          />
          <label htmlFor="customer_id">Enter Customer Id</label>
            <span id="errCustomerNotAuthorized" class="helper-text center yellow red-text " 
                  data-error="wrong" data-success="" 
                  style= {{ fontSize: "small", display: "none", fontWeight: "500" }} ></span>
          <span className="helper-text" data-error="wrong" data-success="">Customer Ezzid ex: Ezz000000</span>
        </div>
      
      </div>
      <div className="row inputbox-height">
        <div className="input-field col s6">
        
          <input name="order_date" id="order_date" type="text"  className="datepicker" 
          value={this.state.order_date}
          />
          
          <label htmlFor="order_date" style={{ marginLeft: '80%' }}><i className="material-icons right">date_range</i></label>
          <span className="helper-text" data-error="wrong" data-success="">Select the date Order Date </span>
        </div>
        <div className="input-field col s6">
          <input name="received_date" id="received_date" type="text" className="datepicker"
           value={this.state.received_date} 
                   />
          <label htmlFor="received_date" style={{ marginLeft: '80%' }}><i className="material-icons right">date_range</i> </label>
          <span className="helper-text" data-error="wrong" data-success="">Select date, the order arrived at warehouse</span>
        </div>
      </div>
      <div className="row inputbox-height">
        <div className="input-field col s6">
          <input name="tracking_number" id="tracking_number" type="text" className=""
           value={this.state.tracking_number} onChange={this.handleFormChange}
          />
          <label htmlFor="tracking_number">Enter Tracking Number</label>
          <span className="helper-text" data-error="wrong" data-success="">Enter Tracking inbound Number</span>

        </div>
        <div className="input-field col s6">
          <input name="shiper_order_number" id="shiper_order_number" type="text" className=""
           value={this.state.shiper_order_number} onChange={this.handleFormChange}
          />
          <label htmlFor="shiper_order_number">Enter Shipper Number</label>
          <span className="helper-text" data-error="wrong" >Enter Shipper Order Number</span>
        </div> 

      </div>
	 
      {
          this.state.showSpinner
            ? < div className="center">
          
            <Spinner animation="grow" variant="primary" size="sm" />
            <Spinner animation="grow" variant="success" size="sm" />
            <Spinner animation="grow" variant="warning" size="sm" />
          </div>
            : null
        }
      
      <div className="row">
      <div className="input-field col s4">
          <input name="weight" id="weight" min="0" type="number" className=""
           value={this.state.weight}  onBlur={(e) => this.changeTo(e)} onChange={(e) => this.updateValue(e)}
          />
          <label className="active" htmlFor="weight">Weight</label>
          <span className="helper-text" data-error="wrong" >Enter Weight in pounds</span>
        </div> 
        <div className="input-field col s4">
          <input name="length"  id="length" min="0" type="number" className=""
           value={this.state.length} onBlur={(e) => this.changeTo(e)} onChange={(e) => this.updateValue(e)}
          />
          <label className="active" htmlFor="length">Length</label>
          <span className="helper-text" data-error="wrong" >Enter Length in inches</span>
        </div>
        <div className="input-field col s4">
          <input name="width" id="width" min="0" type="number" className=""
           value={this.state.width} onBlur={(e) => this.changeTo(e)} onChange={(e) => this.updateValue(e)}
          />
          <label className="active" htmlFor="width">Width</label>
          <span className="helper-text" data-error="wrong" >Enter Width in inches</span>
        </div>
        <div className="input-field col s4">
          <input name="height" id="height" min="0" type="number" className=""
           value={this.state.height} onBlur={(e) => this.changeTo(e)} onChange={(e) => this.updateValue(e)}
          />
          <label className="active" htmlFor="height">Height</label>
          <span className="helper-text" data-error="wrong" >Enter Height in inches</span>
        </div>
              

      </div>
    </form>
  </div>
                    </Col>
                    {/* right side column starts here */}
                    <Col xs={12}md={5} lg={5}>
                    <CustomerDetailCard 
                            info = {this.state.customer_selected_data}
                             />
                        <Row>
                        <Col>
                        <h5>Product Details</h5>
                        </Col>
                        <Col>
                        <Nav className="right">
            <Nav.Link className="red-text modal-trigger "  href="#addProductModal">
                Add<Image className="red-text ml-1" src="assets/images/plus-circle-red.svg"/></Nav.Link>
        </Nav>
                        </Col>
                    </Row>
                    {/* product card to be shown here */}
                    <div className="productlistDiv "><ProductItemsList products={this.state.productlist} rowclick={this.handletableClick}/></div>
					{/* <div className="right"><b>Total Quantity: </b>
                    {
                    ( ()=>{
                      var totalQty =0;
                      this.state.productlist.forEach(function(item){
                        totalQty = totalQty + parseInt(item.productQuantity ) 
                      })
                      return totalQty
                    })()
                      
                      }
        </div><br/>
                    <div className="right"><b>Total Price: </b>$
                    {
                    ( ()=>{
                      var totalprice =0;
                      this.state.productlist.forEach(function(item){
                        totalprice = totalprice + (parseFloat(item.productPrice ).toFixed(2)) *parseInt(item.productQuantity ) 
                      })
                      return parseFloat(totalprice).toFixed(2)  
                    })()
                      
                      }
                      
                      </div> */}
                    </Col>
                   {/* right side columns ends here */}
      
                </Row> 

                <Row >
                  <Col>
                    <div className="left">
                        <h5 className="orange-text">Order Id: <span className="black-text" id='generated_orderId' >{this.state.generatedOrderId}</span></h5>
                    </div>
                  </Col>
                </Row>

          <Row>
            <Col>
              <div className="center">
                <ButtonGroup aria-label="create order buttons" className="">
                  <Button id="cancelOrderBtn"onClick={this.cancelOrder} variant="secondary"  className="">Cancel</Button>
                  <Button className="ml-5 " id="saveOrderBtn" onClick={this.addOrderToDB} variant="primary"  >Create Order</Button>
                  <Button className="ml-5 white-text" id="updateOrder" variant="success" onClick={this.updateOrder} >Update Order</Button>                        
                  {/* <Button className="ml-5 white-text" id="printLabel" variant="warning"  onClick={this.printLabelManually}>Print Order</Button>                         */}
                </ButtonGroup>
              </div>
            </Col>
          </Row>
          </div>
          {/* Create Order div closed here */}
          <div id="divOrderList" style={{ display: "block", width: "100%" }}>
  <Row>
    <Col>
      {/* Scrollable table wrapper */}
      <div style={{ 
        maxHeight: '300px', 
        overflowY: 'auto', 
        overflowX: 'auto', 
        border: '1px solid #ccc', 
        padding: '10px', 
        backgroundColor: '#fff' 
      }}>
        <Table bordered hover size="lg">
          <thead>
            <tr style={{ backgroundColor: '#3a4b00', color: 'white' }}>
              <th>Print</th>
              <th>Edit</th>
              <th>Order Date</th>
              <th>Container No.</th>
              <th>Order No</th>
              <th>EzzId</th>
              <th>Inbound Tracking</th>
              <th>Weight</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {this.state.boxdata.map((row, index) => (
              <tr key={index}>
                <td><Nav.Link className="red-text modal-trigger ">
                                   <Image className="red-text ml-1" src="assets/images/edit.svg" /></Nav.Link></td>
                <td><Nav.Link className="red-text modal-trigger "
                                  onClick={() => this.handleEdit(row)}>
                                   <Image className="red-text ml-1" src="assets/images/edit.svg" /></Nav.Link></td>
                <td>{row.order_date}</td>
                <td>{row.box_id}</td>
                <td>{row.order_id}</td>
                <td>{row.ezz_id}</td>
                <td>{row.inbound_tracking_number}</td>
                <td>{row.weight}</td>
                <td>{row.current_status}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </Col>
  </Row>

  {/* Buttons placed cleanly outside the scrollable area */}
  <Row className="mt-3">
    <Col className="text-center">
      <ButtonGroup aria-label="create order buttons">
        {/* <Button
          id="cancelOrderBtn"
          onClick={this.cancelOrder}
          variant="secondary"
        >
          Cancel
        </Button> */}
        <Button
          className="ml-3"
          id="saveOrderBtn"
          onClick={this.closeContainer}
          variant="primary"
        >
          Close Container
        </Button>
      </ButtonGroup>
    </Col>
  </Row>
</div>
        </Container>


 


    )
}

}

export default CreateOrder;
